import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type VerifyPhoneNumberProps = {
  phone_verification_code: string;
}

export const useVerifyPhoneNumber = () => {
  return useMutation<void, GrapeAPIErrorType, VerifyPhoneNumberProps>({
    mutationFn: async (data: VerifyPhoneNumberProps) => {
      const response = await fetchWithHeaders(
        '/api/web/member_onboarding/phone_verification/verify',
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
          requestId: response.headers.get('x-request-id') ?? undefined,
        })
      }
      return response.json()
    },
  })
}
